import React from 'react';
import { toast, ToastContent, ToastOptions } from 'react-toastify';

import InlineNotification from '../components/snackBar/InlineNotification';
import ToastMessage from '../components/snackBar/ToastMessage';

import aampeTheme from '../constants/aampeTheme';
import ICONS from '../constants/icons';
import {
    ToastDisplayType,
    ToastStatus,
} from '../constants/toastMessage.constants';

class ToastService {
    private static _instance: ToastService;

    static getInstance(): ToastService {
        if (!this._instance) {
            this._instance = new ToastService();
        }
        return this._instance;
    }

    showNotificationToast(
        status: ToastStatus,
        title: string,
        toastType: ToastDisplayType = ToastDisplayType.Snack,
        description?: string,
        actionButton?: { name: string; action: () => void },
        isShowCrossIcon?: boolean,
        config?: ToastOptions,
    ) {
        toast.dismiss();
        toast(
            toastType === ToastDisplayType.Inline ? (
                <InlineNotification
                    status={status}
                    title={title}
                    description={description}
                    actionButton={actionButton}
                />
            ) : (
                <ToastMessage
                    status={status}
                    title={title}
                    description={description}
                    actionButton={actionButton}
                />
            ),
            {
                type: status,
                position: config?.position || 'top-right',
                progressStyle: {
                    backgroundColor: aampeTheme.toastIconColor[status],
                },
                bodyStyle: {
                    display: 'flex',
                    alignItems: 'start',
                },
                style: {
                    width: '360px',
                    marginLeft: '-45px',
                    border:
                        toastType !== ToastDisplayType.Inline
                            ? ''
                            : `1px solid ${aampeTheme.toastIconColor[status]}`,
                    borderRadius:
                        toastType !== ToastDisplayType.Inline
                            ? ''
                            : aampeTheme.borderRadius.default,
                    backgroundColor:
                        toastType !== ToastDisplayType.Inline
                            ? ''
                            : aampeTheme.toastInlineBgColor[status],
                },
                autoClose: actionButton ? false : config?.autoClose ?? 3000,
                closeButton: isShowCrossIcon,
                ...config,
            },
        );
    }
    /**
     * @deprecated These methods are deprecated. Use showNotificationToast instead.
     */
    showError(content: ToastContent, config?: ToastOptions) {
        toast.dismiss();
        toast(content, {
            ...config,
            type: 'error',
            position: config?.position || 'top-right',
            autoClose: config?.delay || 5000,
            bodyStyle: {
                color: `${aampeTheme.colors.error}`,
            },
            progressStyle: {
                backgroundColor: `${aampeTheme.colors.error}`,
            },
            icon: ICONS.error,
        });
    }

    showInfo(content: ToastContent, config?: ToastOptions) {
        toast.dismiss();
        toast(content, {
            ...config,
            type: 'info',
            position: config?.position || 'top-right',
            autoClose: config?.autoClose || 5000,
        });
    }

    showSuccess(content: ToastContent, config?: ToastOptions) {
        toast.dismiss();
        toast(content, {
            ...config,
            type: 'success',
            position: config?.position || 'top-right',
            autoClose: config?.autoClose || 5000,
            bodyStyle: {
                color: `${aampeTheme.colors.success}`,
            },
            progressStyle: {
                backgroundColor: `${aampeTheme.colors.success}`,
            },
            icon: ICONS.check,
        });
    }

    showWarning(content: ToastContent, config?: ToastOptions) {
        toast.dismiss();
        toast(content, {
            ...config,
            type: 'warning',
            position: config?.position || 'top-right',
            autoClose: config?.autoClose || 5000,
        });
    }

    dismiss(toastRef: any) {
        toast.dismiss(toastRef);
    }
}

export const toastService = ToastService.getInstance();
